import type { InputHTMLAttributes, ReactNode, Ref, SelectHTMLAttributes } from 'react';

interface CampoProps extends InputHTMLAttributes<HTMLInputElement> {
  etiqueta: string;
  ayuda?: ReactNode;
  error?: string | null;
  /** React 19 passes ref as an ordinary prop to function components, so no forwardRef needed. */
  ref?: Ref<HTMLInputElement>;
}

export function Campo({ etiqueta, ayuda, error, className = '', ...props }: CampoProps) {
  return (
    <label className="block">
      <span className="etiqueta">{etiqueta}</span>
      <input className={`campo ${error ? 'border-rose-600' : ''} ${className}`} {...props} />
      {error ? (
        <span className="mt-1.5 block text-sm text-rose-400">{error}</span>
      ) : ayuda ? (
        <span className="mt-1.5 block text-xs text-slate-500">{ayuda}</span>
      ) : null}
    </label>
  );
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  etiqueta: string;
  ayuda?: ReactNode;
  children: ReactNode;
}

export function Selector({ etiqueta, ayuda, children, className = '', ...props }: SelectProps) {
  return (
    <label className="block">
      <span className="etiqueta">{etiqueta}</span>
      <select className={`campo ${className}`} {...props}>
        {children}
      </select>
      {ayuda && <span className="mt-1.5 block text-xs text-slate-500">{ayuda}</span>}
    </label>
  );
}

export function Interruptor({
  etiqueta,
  descripcion,
  checked,
  onChange,
}: {
  etiqueta: string;
  descripcion?: string;
  checked: boolean;
  onChange: (v: boolean) => void;
}) {
  return (
    <label className="flex cursor-pointer items-start gap-3 py-2">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 size-5 shrink-0 accent-teal-500"
      />
      <span>
        <span className="block text-sm font-medium">{etiqueta}</span>
        {descripcion && <span className="block text-xs text-slate-500">{descripcion}</span>}
      </span>
    </label>
  );
}
